import api from '../api/apiClient'
import type { HierarchicalReferral, ReferralSummary } from '../models/referral'

export const referralsRepository = {
  getMyReferrals: async (): Promise<HierarchicalReferral[]> => {
    const response = await api.get('/referrals/my-referrals')
    // The API returns data wrapped in an extra array: [[{...}]]
    return response.data.data[0] || []
  },

  getSummary: async (): Promise<ReferralSummary> => {
    const response = await api.get('/referrals/summary')
    return response.data.data
  }
}